export default "__VITE_ASSET__TTP230fJ__"